import React from 'react';
import format from 'string-format';
import PropTypes from 'prop-types';
import _path from 'ramda/src/path';
import resx from '../../../utilities/resx';
import { RESX_GLOBAL } from '../../../Constants';


function ReblastImpressions(props) {
	const isUser = _path(['User2', 'UserId'], RESAAS);
	if (!isUser) {
		return null;
	}

	function renderLikeCaption() {
		let likeCaptionText;
		if (props.data.UserLikedReblast) {
			if (props.data.ReblastLikeCounter === 1) {
				likeCaptionText = resx(RESX_GLOBAL, 'LIKE_COUNT_YOU');
			}
			else if (props.data.ReblastLikeCounter === 2) {
				likeCaptionText = resx(RESX_GLOBAL, 'LIKE_COUNT_YOU_AND_SINGULAR');
			}
			else if (props.data.ReblastLikeCounter > 2) {
				likeCaptionText = format(resx(RESX_GLOBAL, 'LIKE_COUNT_YOU_AND_PLURAL'), props.data.ReblastLikeCounter-1);
			}
		}
		else if (props.data.ReblastLikeCounter === 1) {
			likeCaptionText = resx(RESX_GLOBAL, 'LIKE_COUNT_SINGULAR');
		}
		else if (props.data.ReblastLikeCounter > 1) {
			likeCaptionText = format(resx(RESX_GLOBAL, 'LIKE_COUNT_PLURAL'), props.data.ReblastLikeCounter);
		}

		// note: onClick is handled by re_like_list_control.js, listening to '#ReblastDetailsComponent.re-like-count'
		return (
			likeCaptionText && (<div className="re-like-count js-like-count re-like-component re-icon re-icon-like" data-like-count={props.data.ReblastLikeCounter} data-like-user={props.data.UserLikedReblast} data-id={props.data.ReblastId} data-mixpanel-name="Intent" data-mixpanel-type="View Like List" data-mixpanel-context="reblast">{likeCaptionText}</div>)
		);
	}

	function renderUniqueViewCount() {
		if (!props.data.UniqueViewCount || props.data.UniqueViewCount === '0') {
			return null;
		}
		if (props.data.IsReblastOwner) {
			// note: onClick  is handled by re_reach_list_control.js, listening to '.js-uniqueviewcount'
			return (<button title={resx(RESX_GLOBAL, 'VIEWS_UNIQUECOUNT_TITLE')} className="re-uniqueviewcount js-uniqueviewcount re-icon re-icon-users re-icon-xs" data-reach-count={props.data.UniqueViewCount} data-id={props.data.ReblastId} data-mixpanel-name="Intent" data-mixpanel-type="View Reach List" data-mixpanel-context="reblast">{props.data.UniqueViewCount}</button>);
		}
		return (<span title={resx(RESX_GLOBAL, 'VIEWS_UNIQUECOUNT_TITLE')} className="re-uniqueviewcount re-icon re-icon-users re-icon-xs" data-reach-count={props.data.UniqueViewCount} data-id={props.data.ReblastId}>{props.data.UniqueViewCount}</span>);
	}

	function renderUniqueTotalViews() {
		if (!props.data.TotalViewCount || props.data.TotalViewCount === '0') {
			return null;
		}
		return (
			<span title={resx(RESX_GLOBAL, 'VIEWS_TOTALCOUNT_TITLE')} className="re-totalviewcount re-icon re-icon-eye re-icon-xs" data-impressions-count={props.data.TotalViewCount} data-id={props.data.ReblastId}>{props.data.TotalViewCount}</span>
		);
	}

	return (
		<div className="re-post-engagement">
			{renderLikeCaption()}
			<div className="re-views-data">
				{renderUniqueViewCount()}
				{renderUniqueTotalViews()}
			</div>
		</div>
	);
};
ReblastImpressions.propTypes = {
	data: PropTypes.object.isRequired
};

export default ReblastImpressions;